import { useMediaQuery } from "@mui/material";

/**
 * Custom hook to determine if the screen size is mobile.
 */
export const useIsMobile = () => {
  return useMediaQuery("(max-width:900px)", { noSsr: true });
};



export const useIsCustomScreenSize = () => {
  // Checks if height is between 600px and 800px (inclusive) and width <= 1280px
  return useMediaQuery(
    "(max-width:1280px) and (min-height:600px) and (max-height:800px)",
    { noSsr: true }
  );
};
